import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-supplier-flag-title',
  templateUrl: './supplier-flag-title.component.html',
  styleUrl: './supplier-flag-title.component.css'
})
export class SupplierFlagTitleComponent implements ICellRendererAngularComp {
  params;

  agInit(params): void {
    this.params = params;
  }
  
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
}
